import { createContext } from 'react';
import { OrganisationUnitTreeProviderState } from 'shared/features/organisation/providers/states/organisation-unit-tree-state';

const OrganisationUnitTreeProviderContext = createContext({} as OrganisationUnitTreeProviderState);

export default OrganisationUnitTreeProviderContext;
